import * as React from "react";
import { HashRouter as Router, Switch } from "react-router-dom";
import { AuthorizedRoute } from "@/components/Authorized";
import { AppContext, NftResData } from "./views/context";

import routeConfig from "@/router/router.config";

import "./App.css";

export const LOCAL_KEY = "nft_2022_report";

const mainReducer = (state: NftResData, action: { data: NftResData }) => {
  return { ...action.data };
};

const App = (): JSX.Element => {
  const initial = localStorage.getItem(LOCAL_KEY)
  const initialState = initial ? JSON.parse(initial) : new NftResData();

  const [state, dispatch] = React.useReducer(mainReducer, initialState);


  const renderRoutes = () => (
    <AppContext.Provider value={{ state, dispatch }}>
      <Router>
        <Switch>
          {routeConfig.map((rc) => {
            const { path, component, redirectPath = "/404", ...rest } = rc;
            return (
              <AuthorizedRoute
                key={path}
                path={path}
                component={component}
                redirectPath={redirectPath}
                {...rest}
              />
            );
          })}
        </Switch>
      </Router>
    </AppContext.Provider>
  );

  return <div className="App">{renderRoutes()}</div>;
};

export default App;
